<script setup>
defineProps({
  icon: { type: String, required: true },
  title: { type: String, required: true },
  description: { type: String, default: '' },
});
</script>

<template>
  <div class="flex items-center justify-center h-full min-h-[300px]">
    <div class="flex flex-col items-center gap-4 max-w-md text-center">
      <div class="flex h-16 w-16 items-center justify-center rounded-2xl bg-n-slate-3">
        <i :class="icon" class="w-8 h-8 text-n-slate-11" />
      </div>
      <div class="flex flex-col gap-2">
        <h3 class="text-lg font-medium text-n-slate-12">{{ title }}</h3>
        <p v-if="description" class="text-sm text-n-slate-11">{{ description }}</p>
      </div>
      <slot />
    </div>
  </div>
</template>
